import { useMemo, useState } from "react";
import { trpc } from "@/lib/trpc";

/**
 * Conta de anúncios em uso na tela: a escolhida, senão a padrão, senão a
 * primeira. A lista já vem filtrada pelo servidor (ativas ou padrão, nunca
 * ocultas), então "a primeira" é uma conta que faz sentido.
 */
export function useContaSelecionada() {
  const [accountId, setAccountId] = useState<string | undefined>();
  const accounts = trpc.metaAds.accounts.list.useQuery(undefined, { staleTime: 60_000 });

  const contaSelecionada = useMemo(() => {
    const lista = accounts.data ?? [];
    if (accountId) return lista.find((a) => a.accountId === accountId) ?? null;
    return lista.find((a) => a.isDefault) ?? lista[0] ?? null;
  }, [accounts.data, accountId]);

  return {
    accounts,
    contaSelecionada,
    setAccountId,
    currency: contaSelecionada?.currency ?? null,
    conectado: (accounts.data?.length ?? 0) > 0,
    /** Escrita só é aceita em ACTIVE (1) e IN_GRACE_PERIOD (9). */
    contaBloqueada:
      contaSelecionada?.accountStatus != null && ![1, 9].includes(contaSelecionada.accountStatus),
  };
}
